@if (canGoToForm) {
  <pcg-bill-comparison [BillComparisonFormId]="formId" [UserEmail]="email"></pcg-bill-comparison>
}
@if (!canGoToForm) {
  <h1>Invalid Form Link</h1>
}
@if (!canGoToForm) {
  <pcg-edit-link [url]="'/login'">
    Click here to login.
  </pcg-edit-link>
}